<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :secondary-submit="nextStep"
    :tertiary-submit="prevStep"
    :is-submit-btn="!isView && step === 3"
    :is-secondary-btn="step < 3"
    :is-tertiary-btn="step > 1"
    :submit-btn-text="item.id ? (isApprove ? 'Approve' : 'Update') : 'Create'"
    :secondary-btn-text="'Next'"
    :tertiary-btn-text="'Back'"
    :max-width="1600"
    :scrollable="false"
    :persistent="true"
  >
    <template slot="header">
      <span
        style="font-size: 24px; font-weight: bold;"
        >{{ item.id ? (isApprove ? 'Approve' : isView ? '' : 'Update') : 'Create' }} Delivery Request
        {{ item.id ? `#${item.id}` : '' }}</span
      >
      <v-spacer/>
      <!-- <span>
        {{ item.id ? item.pick_lists && item.pick_lists.length > 0 ? 'Pick List Status: ' : 'No Associated Pick Lists' : ''}}
      </span>
      <v-tooltip
        v-if="item.pick_lists && item.pick_lists.length > 1"
        top
        color="black"
      >
        <template #activator="{ on }">
          <span class="ml-1" style="color: #1976d2" v-on="on">STATUSES</span>
        </template>
        <template v-for="p in item.pick_lists">
          <span v-if="!isBackorderPickList(p)" :key="p.id">
            <span class="mt-1">
              {{ p.code }}
            </span>
            <v-chip
              small
              :color="p.status ? p.status.color : ''"
              class="ml-1 mt-1"
              text-color="white"
            >
              {{ p.status.name ? p.status.name : '' }}
            </v-chip>
            <span v-if="p.created_backorder && p.created_backorder.backorder_part_pick_list">
              <span class="mdi mdi-arrow-right ml-1"></span>
              {{ p.created_backorder.backorder_part_pick_list.code }}
              <v-chip
                small
                :color="p.created_backorder.backorder_part_pick_list.status ? p.created_backorder.backorder_part_pick_list.status.color : ''"
                class="ml-1 mt-1"
                text-color="white"
              >
                {{ p.created_backorder.backorder_part_pick_list.status.name ? p.created_backorder.backorder_part_pick_list.status.name : '' }}
              </v-chip>
            </span>
            <br />
          </span>
        </template>
      </v-tooltip>
      <span class="ml-1" v-else-if="item.pick_lists && item.pick_lists.length === 1">
        {{ item.pick_lists[0].code }}
        <v-chip
          small
          :color="
            item &&
            item.pick_lists &&
            item.pick_lists[0] &&
            item.pick_lists[0].status
              ? item.pick_lists[0].status.color
              : ''
          "
          class="ml-1"
          text-color="white"
        >
          {{
            item &&
            item.pick_lists &&
            item.pick_lists[0] &&
            item.pick_lists[0].status.name
              ? item.pick_lists[0].status.name
              : ''
          }}
        </v-chip>
        <span v-if="item.pick_lists[0].created_backorder && item.pick_lists[0].created_backorder.backorder_part_pick_list">
          <span class="mdi mdi-arrow-right ml-1"></span>
          {{ item.pick_lists[0].created_backorder.backorder_part_pick_list.code }}
          <v-chip
            small
            :color="item.pick_lists[0].created_backorder.backorder_part_pick_list.status ? item.pick_lists[0].created_backorder.backorder_part_pick_list.status.color : ''"
            class="ml-1"
            text-color="white"
          >
            {{ item.pick_lists[0].created_backorder.backorder_part_pick_list.status.name ? item.pick_lists[0].created_backorder.backorder_part_pick_list.status.name : '' }}
          </v-chip>
        </span>
      </span> -->
    </template>
    <template slot="body">
      <v-stepper v-model="step" style="box-shadow: none !important;" non-linear>
        <v-stepper-header>
          <v-stepper-step
            :complete="step > 1"
            step="1"
          >
            Request Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="step > 2"
            step="2"
          >
            {{ (this.isAdmin || this.isDeliveriesManager) ? 'Scheduling and Truck Details' : 'Scheduling Details' }}
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            Cargo Details
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form ref="step1Form">
              <v-row>
                <v-col class="pb-0">
                  <span style="font-size: 18px; color: #000000"
                    >Request Information</span>
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0">
                  <v-autocomplete
                    ref="requestType"
                    v-model="item.request_type_id"
                    :items="requestTypes"
                    item-text="name"
                    item-value="id"
                    :disabled="isView"
                    @change="onRequestTypeChange"
                    :rules="[(v) => !!v || 'Request Type is required']"
                    outlined
                    dense
                  >
                    <template #item="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                    <!-- eslint-disable-next-line vue/no-template-shadow -->
                    <template #selection="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                    <template slot="label">
                      Request Type<RedAsterisk v-if="!isView" />
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="pb-0" v-if="item.request_type_id !== truckScheduleRequestTypeIdPickup">
                  <inventory-class-select-element
                    ref="inventoryClass"
                    v-model="item.inventory_classes"
                    :is-add-all="false"
                    :is-required="!isView"
                    :disabled="isView"
                    :auto-select-first="false"
                    @on-change="onInventoryClassChange"
                    outlined
                    dense
                    multiple
                    return-object
                  />
                </v-col>
              </v-row>
              <v-row v-if="canSelectProjects">
                <v-col class="pb-0">
                  <span style="font-size: 18px; color: #000000"
                    >Project Details</span>
                </v-col>
              </v-row>
              <v-row v-if="canSelectProjects">
                <v-col class="pb-0">
                  <v-autocomplete
                    ref="project"
                    v-model="item.projects"
                    :items="projects"
                    return-object
                    item-text="name"
                    clearable
                    no-data-text='No data available'
                    :loading="loadingProjects"
                    :disabled="
                      (loadingProjects && projects && projects.length === 0) ||
                      isView ||
                      (item.request_type_id !== truckScheduleRequestTypeIdPickup && (item.inventory_classes === null || item.inventory_classes.length === 0))
                    "
                    :rules="isProjectRequired ? [(v) => !!v || 'Project is required'] : []"
                    outlined
                    dense
                    multiple
                    small-chips
                    deletable-chips
                  >
                    <template slot="label">
                      Project<RedAsterisk v-if="!isView && isProjectRequired" />
                    </template>
                    <template #item="{ item }">
                      {{ item ? item.name : '' }}
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <span style="font-size: 18px; color: #000000"
                    >Job Details</span>
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0">
                  <v-autocomplete
                    ref="job"
                    v-model="item.jobs"
                    :items="jobs"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    return-object
                    clearable
                    :no-data-text="
                      item.inventory_classes === null || item.inventory_classes.length === 0
                        ? 'Select an Inventory Class first'
                        : 'No data available'
                    "
                    :loading="loadingJobs"
                    :disabled="
                      item.request_type_id !== truckScheduleRequestTypeIdPickup ?
                      ((loadingJobs && jobs && jobs.length === 0) ||
                      isView ||
                      item.inventory_classes === null || item.inventory_classes.length === 0) :
                      (isView || loadingJobs)
                    "
                    :rules="item.request_type_id === truckScheduleRequestTypeIdDeliveryForProject ? [(v) => !!v || 'Job is required'] : []"
                    outlined
                    dense
                    multiple
                    small-chips
                    deletable-chips
                    prepend-inner-icon="mdi-reload"
                    @click:prepend-inner="getJobs()"
                    @change="onJobChange"
                  >
                    <!-- <template #prepend-inner>
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-icon v-on="on"> mdi-reload </v-icon>
                        </template>
                        <span> Reload Jobs </span>
                      </v-tooltip>
                    </template> -->
                    <template v-if="loadingJobs" #label>
                      Loading Jobs...
                    </template>
                    <template v-else #label>
                      Job<RedAsterisk v-if="!isView && item.request_type_id === truckScheduleRequestTypeIdDeliveryForProject" />
                    </template>
                    <!-- eslint-disable-next-line vue/no-template-shadow -->
                    <!-- <template #selection="{ item }">
                      <v-chip
                        class="mt-1 mb-1 mr-3"
                        small
                        text-color="black"
                        style="cursor: pointer"
                        color="lightgrey"
                      >
                        <span>
                          <span style="font-weight: bold">{{
                            item.code ? `${item.code}` : ''
                          }}</span>
                          - {{ item.name ? item.name : '' }}
                          <span>{{
                            item.reference ? `; ${item.reference} ` : ''
                          }}</span>
                        </span>
                      </v-chip>
                    </template> -->
                    <!-- eslint-disable-next-line vue/no-template-shadow -->
                    <template #item="{ item }">
                      <v-chip
                        v-if="item.sub_class_color || item.sub_class_name"
                        class="mt-1 mb-1 mr-3"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="
                          item && item.sub_class_color ? item.sub_class_color : 'white'
                        "
                      >
                        {{ item && item.sub_class_name ? item.sub_class_name : '' }}
                      </v-chip>
                      <span>
                        <span style="font-weight: bold">{{
                          item.code ? `${item.code}` : ''
                        }}</span>
                        - {{ item.name ? item.name : '' }}
                        <span style="color: #1976d2">{{
                          item.reference ? `; ${item.reference} ` : ''
                        }}</span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <!-- Finished Goods Summary -->
              <v-row>
                <v-col cols="2" class="pb-0" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Release Qty:
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalReleaseQuantity }}
                  </span>
                  <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalReleaseQuantity }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" class="pb-0" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Windows: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalWindows }}
                  </span>
                  <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalWindows }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" class="pb-0" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total CPs: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalCPs }}
                  </span>
                  <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalCPs }}
                  </v-chip>
                  -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" class="pb-0" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Euro Doors: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalEuroDoors }}
                  </span>
                 <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalEuroDoors }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" class="pb-0" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Patio Doors: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalPatioDoors }}
                  </span>
                 <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalPatioDoors }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
              </v-row>
              <!-- <v-row class="mt-0">
                <v-col>
                  <span>{{ `${item && item.jobs ? item.jobs.length : 0} job${item && item.jobs && item.jobs.length === 1 ? '' : 's'} selected`}}</span>
                </v-col>
                <v-col class="text-end" v-if="item.jobs && item.jobs.length > 0 && !isView">
                  <span style="cursor: pointer;" @click="clearJobs">Clear all</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-list class="job-list">
                    <div v-if="!item.jobs || item.jobs.length === 0" class="d-flex align-center justify-center fill-height">
                      <span style="color: rgba(0, 0, 0, 0.6)">No Jobs Selected</span> 
                    </div>
                    <template v-for="(job, index) in item.jobs" >
                      <v-list-item :key="index" two-line>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span>
                              <span style="font-weight: bold">{{
                                job.code ? `${job.code}` : ''
                              }}</span>
                              - {{ job.name ? job.name : '' }}
                              <span style="color: #1976d2">{{
                                job.reference ? `; ${job.reference} ` : ''
                              }}</span>
                            </span>
                          </v-list-item-title>
                          <v-list-item-subtitle>{{job.project ? job.project.name : 'No Associated Project'}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-row>
                            <v-col>
                              <v-btn color="warning" depressed @click="openNoteForm(job)">
                                ADD NOTE
                              </v-btn>
                            </v-col>
                            <v-col class="pl-0">
                              <v-btn
                                icon
                                color="error"
                                @click="removeJob(job)"
                              >
                                <v-icon>
                                  mdi-close
                                </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider
                        v-if="item.jobs && index < item.jobs.length - 1"
                        class="mx-4"
                        :key="`divider-${index}`"
                      ></v-divider>
                    </template>
                  </v-list>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" outlined>
                    <div class="dr-tabs-row">
                      <v-tabs
                        v-model="activeTab"
                        background-color="transparent"
                        color="black"
                        slider-color="black"
                      >
                        <v-tab
                          v-for="(tab, index) in tabs"
                          :key="index"
                        >
                          <v-icon small class="mr-2">
                            {{ tab.icon }}
                          </v-icon>

                          {{ tab.label }}

                          <v-badge
                            class="ml-2"
                            :content="tab.count"
                            inline
                            color="black"
                          />
                        </v-tab>
                      </v-tabs>
                    </div>

                    <v-divider />

                    <v-tabs-items v-model="activeTab">
                      <v-tab-item>
                        <v-data-table
                          :headers="jobHeaders"
                          :items=" item && item.jobs ? item.jobs : []"
                          hide-default-footer
                          class="dr-table"
                          height="400px"
                        >
                          <template #[`item.inventory_class`]="{ item }">
                            <v-chip
                              small
                              :color="item && item.class ? item.class.color : 'black'"
                              text-color="white"
                            >
                              {{ item && item.class ? item.class.name : '' }}
                            </v-chip>
                          </template>
                          <template #[`item.job`]="{ item }">
                            <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.project ? item.project.name : item.name }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
                          </template>
                          <template #[`item.note`]="{ item }">
                            <v-textarea
                              v-model="item.note"
                              :disabled="isView"
                              rows="1"
                              auto-grow
                            />
                          </template>
                          <template #[`item.actions`]="{ item }">
                            <v-btn
                              v-if="!isView"
                              icon
                              color="error"
                              @click="removeJob(item)"
                            >
                              <v-icon>
                                mdi-close
                              </v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-tab-item>
                      <v-tab-item>
                        <v-data-table
                          :headers="projectHeaders"
                          :items=" item && item.projects ? item.projects : []"
                          hide-default-footer
                          class="dr-table"
                          height="400px"
                        >
                          <template #[`item.note`]="{ item }">
                            <v-textarea
                              v-model="item.note"
                              :disabled="isView"
                              rows="1"
                              auto-grow
                            />
                          </template>
                          <template #[`item.actions`]="{ item }">
                            <v-btn
                              icon
                              color="error"
                              @click="removeProject(item)"
                            >
                              <v-icon>
                                mdi-close
                              </v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-form ref="step2Form">
              <v-row>
                <v-col class="pb-0">
                  <span style="font-size: 18px; color: #000000"
                    >Scheduling</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="item.date"
                        append-icon="mdi-calendar"
                        readonly
                        :rules="[v => !!v || 'Requested Delivery Date is required']"
                        :disabled="isView || !!(item && item.id && item.slot !== null)"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      >
                        <template slot="label">
                          Requested Delivery Date<RedAsterisk v-if="!isView" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="item.date"
                      :allowed-dates="allowedDates"
                      :disabled="isView || !!(item && item.id && item.slot !== null)"
                      @change="onDateChange"
                      @input="datePickerMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="pb-0">
                  <v-autocomplete
                    ref="shift"
                    v-model="item.request_shift_id"
                    :items="shifts"
                    item-text="name"
                    item-value="id"
                    clearable
                    :rules="[(v) => !!v || 'Shift is required']"
                    :disabled="isView"
                    outlined
                    dense
                  >
                    <template #item="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                    <!-- eslint-disable-next-line vue/no-template-shadow -->
                    <template #selection="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                    <template slot="label">
                      Shift<RedAsterisk v-if="!isView" />
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <!-- Finished Goods Summary -->
              <v-row>
                <v-col cols="2" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Release Qty: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalReleaseQuantity }}
                  </span>
                  <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    :color="'black'"
                    text-color="white"
                    inline
                  >
                    {{ totalReleaseQuantity }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Windows: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalWindows }}
                  </span>
                  <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalWindows }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total CPs: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalCPs }}
                  </span>
                  <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalCPs }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Euro Doors: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalEuroDoors }}
                  </span>
                 <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalEuroDoors }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
                <v-col cols="2" style="display: flex !important; align-items: center !important;">
                  <span style="font-size: 16px; font-weight: 500;">
                    Total Patio Doors: 
                  </span>
                  <span v-if="!loadingProductionSchedules" style="font-size: 16px; font-weight: 500;" class="ml-2">
                    {{ totalPatioDoors }}
                  </span>
                 <!-- <v-chip
                    v-if="!loadingProductionSchedules"
                    class="ml-2"
                    color="black"
                    text-color="white"
                    inline
                  >
                    {{ totalPatioDoors }}
                  </v-chip> -->
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="20"
                    width="2"
                    color="grey"
                    class="v-progress-circular--visible"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <span style="font-size: 18px; color: #000000"
                    >Truck Type</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-1">
                  <span style="font-size: 14px;">
                    Truck types available for selection are based on the selected date. Please select a date to view available truck types.
                  </span>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col class="pb-0">
                  <v-autocomplete
                    ref="truckType"
                    v-model="item.truck_type_id"
                    :items="truckTypes"
                    :loading="loadingAvailableTruckTypesByDate"
                    item-text="name"
                    item-value="id"
                    clearable
                    :rules="[
                      v => {
                        if (Array.isArray(v)) {
                          return v.length > 0 || 'Truck is required';
                        }
                        return !!v || 'Truck Type is required';
                      }
                    ]"
                    :disabled="isView || item.date === null"
                    :no-data-text="
                      item.date === null
                        ? 'Please select a date first'
                        : 'No data available'
                    "
                    @change="onTruckTypeChange"
                    outlined
                    dense
                  >
                    <template #item="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                      <span style="font-size: 0.8rem; font-weight: bold; margin-left: 2px;">
                        : {{ item.count }}
                      </span>
                    </template>
                    <template #selection="{ item }">
                      <v-chip
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="item ? item.color : 'white'"
                      >
                        {{ item ? item.name : '' }}
                      </v-chip>
                    </template>
                    <template slot="label">
                      Truck Type<RedAsterisk v-if="!isView" />
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="pb-0" cols="2">
                  <v-text-field
                    v-model="item.truck_quantity"
                    :rules="[
                      v => !!v || 'Truck quantity is required',
                      v => /^\d+$/.test(v) || 'Please enter a whole number',
                      v => Number(v) > 0 || 'Truck quantity must be greater than 0',
                      v => getMaxTruckQuantity() === null || Number(v) <= getMaxTruckQuantity() || `Maximum allowed is ${getMaxTruckQuantity()}`
                    ]"
                    type="number"
                    step="1"
                    label="Truck Quantity"
                    :disabled="isView || item.truck_type_id === null"
                    outlined
                    dense
                  />
                </v-col>
              </v-row> -->
              <v-row>
                <v-col :class="`py-0 ${loadingTruckTypes || loadingAvailableTruckTypesByDate ? 'd-flex align-center justify-center' : ''}`">
                  <!-- <v-btn
                    v-for="type in truckTypes"
                    class="ma-1 truck-type-btn"
                    :key="type.id"
                    small
                    outlined
                    :style="{
                      backgroundColor: isSelected(type) ? type.color : 'transparent',
                      border: `1px solid ${type.color}`,
                      color: isSelected(type) ? 'white !important' : `${type.color} !important`
                    }"
                    @click="toggleType(type)"
                  >
                    <v-icon left small>
                      {{ isSelected(type) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                    </v-icon>
                    {{ type.name }}
                  </v-btn> -->
                  <!-- <v-chip-group
                    multiple
                    column
                  >
                    <v-chip
                      v-for="type in truckTypes"
                      :key="type.id"
                      class="ma-1"
                      :outlined="!isSelected(type)"
                      :style="getTruckTypeChipStyle(type)"
                      @click="toggleType(type)"
                    >
                      <v-icon left small>
                        {{ isSelected(type) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                      </v-icon>
                      {{ type.name }}
                    </v-chip>
                  </v-chip-group> -->
                  <v-progress-circular
                    v-if="loadingTruckTypes || loadingAvailableTruckTypesByDate"
                    indeterminate
                    :size="80"
                    :width="4"
                    class="v-progress-circular--visible"
                  />
                  <v-chip-group v-else multiple column>
                    <v-chip
                      v-for="type in truckTypes"
                      :key="type.id"
                      large
                      class="ma-1 truck-type-chip"
                      :disabled="isView || item.date === null"
                      :outlined="!isSelected(type.id)"
                      :style="getTruckTypeChipStyle(type.id)"
                      @click="toggleType(type.id)"
                    >
                      <!-- <v-icon left medium>
                        {{ isSelected(type.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                      </v-icon> -->

                      <!-- <v-icon left small>
                        mdi-truck
                      </v-icon> -->

                      <span>{{ type.name }}</span>
                      <span :style="{ marginLeft: '6px', fontWeight: 'bold', color: isSelected(type.id) ? 'white' : 'black' }">
                        {{ type.count ? `(${type.count})` : '' }}
                      </span>

                      <template>
                        <div
                          class="d-flex align-center ml-4"
                          :style="{ border: `1px solid ${isSelected(type.id) ? 'white' : type.color}`, borderRadius: '4px', padding: '6px 6px' }"
                          @click.stop
                        >
                          <v-btn
                            icon
                            x-small
                            @click.stop="updateQuantity(type.id, -1)"
                          >
                            <v-icon x-small :style="{ color: `${isSelected(type.id) ? 'white' : type.color}` }">mdi-minus</v-icon>
                          </v-btn>

                          <span
                            class="mx-1"
                            :style="{ minWidth: '18px', textAlign: 'center', color: `${isSelected(type.id) ? 'white' : type.color}` }"
                          >
                            {{ getTruckTypeQuantity(type.id) || 0 }}
                          </span>

                          <v-btn
                            icon
                            x-small
                            @click.stop="updateQuantity(type.id, 1)"
                          >
                            <v-icon x-small :style="{ color: `${isSelected(type.id) ? 'white' : type.color}` }">mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <!-- Truck type selection grid -->
                  <!-- <div>
                    <div class="d-flex flex-wrap" style="gap: 8px;">
                      <v-btn
                        v-for="type in truckTypes"
                        :key="type"
                        small
                        outlined
                        :color="isSelected(type) ? 'primary' : 'grey'"
                        :class="{
                          'primary--text': isSelected(type),
                        }"
                        @click="toggleType(type)"
                      >
                        <v-icon left small>
                          {{ isSelected(type) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                        </v-icon>
                        {{ type.name }}
                      </v-btn>
                    </div>
                  </div> -->

                  <!-- Quantity configuration for selected types -->
                    <!-- <span>
                      Quantities
                    </span>

                    <v-card
                      v-for="selectedTruckType in item.truck_types"
                      :key="selectedTruckType.id"
                      outlined
                      class="mb-2"
                    >
                      <v-card-text class="py-3 px-4 d-flex align-center justify-space-between">
                        <div class="d-flex align-center">
                          <div
                            class="d-flex align-center justify-center mr-3"
                            style="
                              height: 32px;
                              width: 32px;
                              border-radius: 4px;
                              background: #f5f5f5;
                            "
                          >
                            <v-icon :style="{ color: selectedTruckType.type ? selectedTruckType.type.color : 'black' }">mdi-truck</v-icon>
                          </div>

                          <span style="font-weight: 500;">
                            {{ selectedTruckType.type ? selectedTruckType.type.name : '-' }}
                          </span>
                        </div>

                        <div class="d-flex align-center">
                          <div
                            class="d-flex align-center mr-2"
                            style="
                              border: 1px solid #e0e0e0;
                              border-radius: 6px;
                              overflow: hidden;
                            "
                          >
                            <v-btn
                              icon
                              small
                              :disabled="selectedTruckType.quantity <= 1"
                              @click="updateQuantity(selectedTruckType.id, -1)"
                            >
                              <v-icon small>mdi-minus</v-icon>
                            </v-btn>

                            <div
                              class="text-center font-weight-bold"
                              style="min-width: 32px;"
                            >
                              {{ selectedTruckType.quantity }}
                            </div>

                            <v-btn
                              icon
                              small
                              @click="updateQuantity(selectedTruckType.id, 1)"
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </div>

                          <v-btn
                            icon
                            small
                            @click="removeType(selectedTruckType.id)"
                          >
                            <v-icon small color="grey darken-1">mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card> -->

                    <!-- Summary -->
                    <span>
                      Total:
                      <!-- <v-chip color="secondary">
                        {{ getTotalTruckTypeQuantity() }} trucks
                      </v-chip> -->
                      {{ getTotalTruckTypeQuantity() }} truck{{ getTotalTruckTypeQuantity() === 1 ? '' : 's' }}
                    </span>


                  <!-- Empty state -->
                  <!-- <p
                    v-else
                    class="text-sm grey--text text--darken-1 font-italic mt-4 mb-0"
                  >
                    No truck types selected
                  </p> -->
                </v-col>
              </v-row>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-row v-if="this.isAdmin || this.isDeliveriesManager" >
              <v-col class="pb-0">
                <span style="font-size: 18px; color: #000000"
                  >Cages</span>
              </v-col>
            </v-row>
            <v-row v-if="(this.isAdmin || this.isDeliveriesManager) && Object.keys(cageQuantities).length > 0">
              <v-col
                v-for="(cage, index) in cageTypes"
                :key="index"
                class="pb-0 d-flex align-center"
              >
                <v-checkbox v-if="cage.max_quantity === 1"
                  v-model.number="cageQuantities[cage.id].quantity"
                  :label="cage.name"
                  :disabled="isView"
                  :true-value="1"
                  :false-value="0"
                  class="mt-0 pt-0"
                >
                </v-checkbox>
                <v-text-field
                  v-else
                  v-model.number="cageQuantities[cage.id].quantity"
                  :rules="[
                    v => v === null || v === '' || v === undefined || /^\d+$/.test(v) || 'Please enter a whole number',
                    v => cage.max_quantity === null || v === null || v === '' || v === undefined || Number(v) <= cage.max_quantity || `Maximum allowed is ${cage.max_quantity}`
                  ]"
                  :step="1"
                  type="number"
                  :label="cage.name"
                  :disabled="isView"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-0">
                <span style="font-size: 18px; color: #000000">
                  Pick Lists
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <span style="font-size: 14px;">
                  View associated pick lists for the selected job(s) below. Click on a pick list to view details.
                </span>
              </v-col>
            </v-row>
            <v-row v-if="loadingPickLists">
              <v-col class="d-flex align-center justify-center" cols="12" style="height: 250px;">
                <v-progress-circular
                  indeterminate
                  :size="70"
                  :width="4"
                  class="v-progress-circular--visible"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="pt-0">
                <v-list id="pick-list" class="job-list">
                  <div v-if="!item.jobs || item.jobs.length === 0" class="d-flex align-center justify-center fill-height">
                      <span style="color: rgba(0, 0, 0, 0.6)">No Jobs Selected</span> 
                  </div>
                  <template v-for="(job, index) in item.jobs" >
                    <v-list-item :key="index" two-line>
                      <v-list-item-content>
                        <v-list-item-title>
                          <span>
                            <span style="font-weight: bold">{{
                              job.code ? `${job.code}` : ''
                            }}</span>
                            - {{ job.name ? job.name : '' }}
                            <span style="color: #1976d2">{{
                              job.reference ? `; ${job.reference} ` : ''
                            }}</span>
                          </span>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{job.project ? job.project.name : 'No Associated Project'}}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-row>
                          <v-col>
                            <div v-if="job.pick_lists && job.pick_lists.length > 0" class="picklists-wrap">
                              <v-tooltip
                                v-for="(pl, i) in job.pick_lists.slice(0, 4)"
                                :key="`pl-inline-${job.id}-${i}`"
                                top
                                color="black"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    v-on="on"
                                    v-bind="attrs"
                                    medium
                                    label
                                    outlined
                                    color="success"
                                    @click="openPickListForm(pl.id)"
                                    class="ma-1"
                                  >
                                    {{ pl.code}}
                                  </v-btn>
                                </template>
                                <span>
                                  Status: 
                                </span>
                                <v-chip
                                  small
                                  :color="pl.status ? pl.status.color : ''"
                                  class="ml-1"
                                  text-color="white"
                                >
                                  {{ pl.status && pl.status.name ? pl.status.name : '' }}
                                </v-chip>
                              </v-tooltip>
                              <v-menu
                                v-if="job.pick_lists.length > 4"
                                offset-y
                                max-width="420"
                                :close-on-content-click="false"
                              >
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    v-on="on"
                                    v-bind="attrs"
                                    medium
                                    outlined
                                    color="success"
                                    class="ma-1"
                                  >
                                    +{{ job.pick_lists.length - 4 }}
                                    <v-icon right small>mdi-menu-down</v-icon>
                                  </v-btn>
                                </template>

                                <v-card>
                                  <v-card-title class="py-2 text-subtitle-2">
                                    Pick Lists
                                  </v-card-title>

                                  <v-divider />

                                  <v-card-text class="py-2">
                                    <div class="picklists-menu-wrap">
                                      <v-tooltip
                                        v-for="(pl, i) in job.pick_lists.slice(4)"
                                        :key="`pl-menu-${job.id}-${i}`"
                                        top
                                        color="black"
                                      >
                                        <template #activator="{ on, attrs }">
                                          <v-btn
                                            v-on="on"
                                            v-bind="attrs"
                                            medium
                                            outlined
                                            color="success"
                                            class="ma-1"
                                            @click="openPickListForm(pl.id)"
                                          >
                                            {{ pl.code }}
                                          </v-btn>
                                        </template>

                                        <span>Status:</span>
                                        <v-chip
                                          small
                                          :color="pl.status ? pl.status.color : ''"
                                          class="ml-1"
                                          text-color="white"
                                        >
                                          {{ pl.status && pl.status.name ? pl.status.name : '' }}
                                        </v-chip>
                                      </v-tooltip>
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </div>
                            <span v-else style="font-size: 16px;">
                              No Pick Lists associated with this Job
                            </span>
                          </v-col>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-if="item.jobs && index < item.jobs.length - 1"
                      class="mx-4"
                      :key="`divider-${index}`"
                    ></v-divider>
                  </template>
                </v-list>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col>
                <v-chip-group v-if="item.pick_lists && item.pick_lists.length > 0">
                  <v-tooltip
                    v-for="(item, i) in item.pick_lists"
                    :key="i"
                    top
                    color="black"
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        medium
                        label
                        outlined
                        color="success"
                        @click="openPickListForm(item.id)"
                        class="ma-1"
                      >
                        {{ item.code}}
                      </v-btn>
                    </template>
                    <span>
                      Status: 
                    </span>
                    <v-chip
                      small
                      :color="item.status ? item.status.color : ''"
                      class="ml-1"
                      text-color="white"
                    >
                      {{ item.status.name ? item.status.name : '' }}
                    </v-chip>
                  </v-tooltip>
                </v-chip-group>
                <span v-else style="font-size: 16px;">
                  No Pick Lists associated with the selected Job
                </span>
              </v-col>
            </v-row> -->
            <!-- <v-row>
              <v-col class="pb-0">
                <span style="font-size: 18px; color: #000000"
                  >Installation Material</span>
              </v-col>
            </v-row> -->
            <!-- <v-row style="background-color: #d2f2d4">
              <v-col>
              <v-row>
                <v-col class="pb-0">
                  <span class="ml-4" style="font-size: 18px; color: #164f2c"
                    >Installation Material</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    class="ml-4 mb-4"
                    color="success"
                    :loading="loading"
                    @click="openInstallationMaterialForm">
                    Add Installation Materials
                  </v-btn>
                </v-col>
              </v-row>
              </v-col>
            </v-row> -->
            <!-- <div class="mb-3" style="background-color: #d2f2d4; border-radius: 5px">
              <div class="ml-4">
                <v-row>
                  <v-col class="pb-0">
                    <span style="font-size: 18px; color: #164f2c"
                      >Installation Material</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-1 pb-0">
                    <span style="font-size: 14px; color: #164f2c"
                      >Create a pick list of installation materials by clicking the button below</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      color="success"
                      :loading="loading"
                      @click="openPartPickListForm">
                      Add Installation Materials
                      {{ totalInstallationMaterialCount > 0 ? `(${totalInstallationMaterialCount})` : '' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div> -->
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    <!-- <part-pick-list-form ref="partPickListForm" :is-creating-from-truck-schedule-request="true" @success="partPickListFormSuccess"/> -->
    <job-form
      ref="jobForm"
      :is-supervisor="false"
      :is-client="false"
      :is-work-order="false"
      :is-address="false"
      :is-job-name="false"
      :is-reference="true"
      @success="jobSuccess"
    />
    <note-form v-show="false" ref="noteForm" @success="noteSuccess"/>
    <part-pick-list-form
      ref="partForm"
    />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import TruckScheduleRequestInstallationMaterialForm from '@/components/forms/truckSchedules/TruckScheduleRequestInstallationMaterialForm.vue';
import PartPickListForm from '@/components/forms/partPickLists/PartPickListForm.vue';
import JobForm from '@/components/forms/jobs/JobForm';
import NoteForm from '@/components/forms/notes/NoteForm';


export default {
  components: {
    TruckScheduleRequestInstallationMaterialForm,
    PartPickListForm,
    JobForm,
    NoteForm,
  },
  data: () => ({
    roles: [],
    item: null,
    itemDto: {
      id: 0,
      request_type_id: null,
      date: null,
      // truck_types: [],
      truck_type_id: null,
      // trucks: [],
      // job_id: null,
      jobs: [],
      projects: [],
      inventory_classes: [],
      // project_id: null,
      // inventory_class_id: null,
      // big_cage_quantity: 0,
      // medium_cage_quantity: 0,
      // small_cage_quantity: 0,
      cage_quantities: [],
      request_shift_id: null,
      truck_types: [],
      // truck_quantity: null,
      note: null,
    },
    cageQuantities: {},
    // partPickList: null,
    // partPickListDto: {
    //   id: 0,
    //   // inventory_class_id: 4,
    //   project_id: null,
    //   job_id: null,
    //   department_id: null,
    //   items: [],
    //   bill_of_lading_extra_items: [],
    //   note: null,
    // },

    requestTypes: [],
    jobs: [],
    projects: [],
    truckTypes: [],
    trucks: [],
    shifts: [],
    cageTypes: [],
    pickLists: [],
    availableTruckTypesByDate: {},
    
    userRoleIdAdmin: 3,
    userRoleIdDeliveriesManager: 31,
    userRoleIdDeliveriesRequester: 32,
    inventoryClassId4500: 1,
    inventoryClassId4800: 2,
    inventoryClassIdInst: 4,
    inventoryClassIdComm: 6,
    truckScheduleRequestTypeIdPickup: 1,
    truckScheduleRequestTypeIdDeliveryForProject: 2,
    truckScheduleRequestTypeIdNonWindowDelivery: 3,
    noteTypeIdPickList: 6,
    noteTypeIdTruckScheduleRequestJob: 15,
    pickListStatusIdNew: 1,
    pickListStatusIdPartiallySupplied: 2,
    pickListStatusIdSupplied: 3,
    pickListStatusIdShipped: 4,

    datePickerMenu: false,
    isView: false,
    isApprove: false,
    loading: false,
    loadingJobs: false,
    loadingProjects: false,
    loadingTruckTypes: false,
    loadingAvailableTruckTypesByDate: false,
    loadingPickLists: false,
    loadingProductionSchedules: false,
    filterTruckTypeId: null,
    step: 1,

    activeTab: 0,
    jobHeaders: [
      { text: "Class", value: "inventory_class", align: "center", width: "5%", sortable: false },
      { text: "WO#", value: "code", width: "10%", sortable: false },
      { text: "Job", value: "job", width: "20%", sortable: false  },
      { text: "Note", value: "note", width: "60%", sortable: false  },
      { text: "Actions", value: "actions", align: "center", width: "5%", sortable: false },
    ],
    projectHeaders: [
      { text: 'Project Name', value: 'name', width: '15%', sortable: false },
      { text: "Note", value: "note", width: "85%", sortable: false  },
      { text: "Actions", value: "actions", align: "center", width: "5%", sortable: false },
    ],
  }),
  computed: {
    ...mapState({
      isDarkMode: 'isDarkMode',
      user: (state) => state.user,
    }),
    ...mapGetters(['businessRulesGetBoolean']),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    isDeliveriesManager() {
      return this.roles.includes(this.userRoleIdDeliveriesManager);
    },
    isDeliveriesRequester() {
      return this.roles.includes(this.userRoleIdDeliveriesRequester);
    },
    // minDeliveryDate() {
    //   return moment(new Date().toLocaleDateString('en-US'))
    //     .subtract(1, 'days')
    //     .format('YYYY-MM-DD');
    // },
    totalInstallationMaterialCount() {
      const items = this.partPickList?.items?.length || 0;
      const extras = this.partPickList?.bill_of_lading_extra_items?.length || 0;
      return items + extras;
    },
    canSelectProjects() {
      return this.item.request_type_id === this.truckScheduleRequestTypeIdPickup || this.item.request_type_id === this.truckScheduleRequestTypeIdNonWindowDelivery;
    },
    isProjectRequired() {
      return this.item.request_type_id === this.truckScheduleRequestTypeIdPickup || this.item.request_type_id === this.truckScheduleRequestTypeIdNonWindowDelivery;
    },
    tabs() {
      // if request type is Non-window delivery or Pickup then show both jobs and projects tabs, otherwise show only jobs tab
      const showProjects = this.item.request_type_id === this.truckScheduleRequestTypeIdPickup || this.item.request_type_id === this.truckScheduleRequestTypeIdNonWindowDelivery;

      const tabs = [
        {
          key: "jobs",
          label: "Jobs",
          icon: "mdi-briefcase-outline",
          count: this.item && this.item.jobs && Number.isInteger(this.item.jobs.length) ? this.item.jobs.length.toString() : "0",
        },
      ]

      if (showProjects) {
        tabs.push(
          {
            key: "projects",
            label: "Projects",
            icon: "mdi-ruler",
            count: this.item && this.item.projects && Number.isInteger(this.item.projects.length) ? this.item.projects.length.toString() : "0",
          }
        );
      }

      return tabs;
    },
    totalReleaseQuantity() {
      return parseInt(this.totalWindows + this.totalCPs + this.totalEuroDoors + this.totalPatioDoors);
    },
    totalWindows() {
      //use job.window_verticals
      //if job_sub_class_id is 2 (Corner Post) then do not count them
      if (!this.item.jobs || this.item.jobs.length === 0) return 0;
      let count = 0;
      this.item.jobs.forEach(job => {
        if (job.sub_class_id !== 2) {
          if (job.production_schedules && job.production_schedules.length > 0) {
            job.production_schedules.forEach(ps => {
              count += ps.window_verticals ? ps.window_verticals : 0;
            });
          }
        }
      });
      return parseInt(count);
    },
    totalCPs() {
      //if job_sub_class_id is 2 (Corner Post) then use job.window_verticals
      if (!this.item.jobs || this.item.jobs.length === 0) return 0;
      let count = 0;
      this.item.jobs.forEach(job => {
        if (job.sub_class_id === 2) {
          if (job.production_schedules && job.production_schedules.length > 0) {
            job.production_schedules.forEach(ps => {
              count += ps.window_verticals ? ps.window_verticals : 0;
            });
          }
        }
      });
      return parseInt(count);
    },
    totalEuroDoors() {
      //use job.euro_doors
      if (!this.item.jobs || this.item.jobs.length === 0) return 0;
      let count = 0;
      this.item.jobs.forEach(job => {
        if (job.production_schedules && job.production_schedules.length > 0) {
          job.production_schedules.forEach(ps => {
            count += ps.euro_doors ? ps.euro_doors : 0;
          });
        }
      });
      return parseInt(count);
    },
    totalPatioDoors() {
      //use job.patio_doors
      if (!this.item.jobs || this.item.jobs.length === 0) return 0;
      let count = 0;
      this.item.jobs.forEach(job => {
        if (job.production_schedules && job.production_schedules.length > 0) {
          job.production_schedules.forEach(ps => {
            count += ps.patio_doors ? ps.patio_doors : 0;
          });
        }
      });
      return parseInt(count);
    },
    summaryItems() {
      return [
        { label: 'Total Release Quantity', value: this.totalReleaseQuantity },
        { label: 'Total Windows', value: this.totalWindows },
        { label: 'Total CPs', value: this.totalCPs },
        { label: 'Total Euro Doors', value: this.totalEuroDoors },
        { label: 'Total Patio Doors', value: this.totalPatioDoors },
      ];
    },
  },
  watch: {
    // 'item.inventory_class_id': {
    //   handler(newVal) {
    //     if (newVal == null) return;
    //     console.log('Inventory Class Changed:', newVal);
    //     // if (!this.isInit) {
    //     //   this.item.job_id = null;
    //     //   this.item.project_id = null;
    //     // }
    //     if (
    //       newVal === this.inventoryClassId4500 ||
    //       newVal === this.inventoryClassId4800
    //     ) {
    //       this.getJobs();
    //     }
    //   },
    //   immediate: true,
    // },
    'item.jobs': {
      handler(newVal) {
        if (newVal == null) return;
          this.getPickLists();
      },
      immediate: true,
    },
  },
  async created() {
    this.roles = this.user.roles.map((x) => x.id);
    this.item = { ...this.itemDto };
    // this.partPickList = { ...this.partPickListDto };
    this.getRequestTypes();
    this.getProjects();
    // this.getTruckTypes();
    this.getShifts();
    await this.getCageTypes();
    this.cageQuantities = {};
    this.cageTypes.forEach(ct => {
      this.cageQuantities[ct.id] = {
        id: null,
        truck_schedule_request_cage_type_id: ct.id,
        quantity: 0
      };
    });
  },
  methods: {
    async get(id) {
      if (!id) return;
      this.loading = true;

      const submitModel = {
        filters: {
          id,
        },
        // with: ['jobs_pick_lists'],
      };
      const res = await this.$api.truckScheduleRequest.read(submitModel);
      const firstIndex = 0;
      if (!res || !res.data || !res.data[firstIndex]) {
        this.loading = false;
        this.$bus.$emit('showError', 'Unable to retrieve Truck Request');
        return;
      }
      this.item = res.data[firstIndex];
      this.filterTruckTypeId = this.item.truck_id;

      this.cageQuantities = {};
      this.cageTypes.forEach(ct => {
        const match = this.item.cage_quantities.find(eq => eq.truck_schedule_request_cage_type_id === ct.id);

        this.cageQuantities[ct.id] = {
          id: match ? match.id : null,
          truck_schedule_request_cage_type_id: ct.id,
          quantity: match ? match.quantity : 0
        };
      });
      this.cageQuantities = JSON.parse(JSON.stringify(this.cageQuantities));
      // if (this.item.pick_lists && this.item.pick_lists.length > 0) {
      //   //retrieve the pick lists from PartPickList API if pick lists exists for the truck schedule request
      //   const submitModel2 = {
      //     filters: {
      //       truck_schedule_request_id: id,
      //       is_truck_request: 1,
      //     }
      //   }
      //   const res2 = await this.$api.partPickList.read(submitModel2, {}, 'read/truck-schedule-request');
      //   if (!res2 || !res2.data) {
      //     this.loading = false;
      //     this.$bus.$emit('showError', 'Unable to retrieve Pick List');
      //     return;
      //   }
      //   this.partPickList = res2.data ? res2.data : { ...this.partPickListDto };
      // } else {
      //   this.partPickList = { ...this.partPickListDto };
      // }

      // const submitModel2 = {
      //   filters: {
      //     truck_schedule_request_id: id,
      //     is_truck_request: 1,
      //   }
      // }
      // const res2 = await this.$api.partPickList.read(submitModel2, {}, 'read/truck-schedule-request');
      // if (!res2 || !res2.data) {
      //   this.loading = false;
      //   this.$bus.$emit('showError', 'Unable to retrieve Pick List');
      //   return;
      // }
      // this.partPickList = res2.data ? res2.data : { ...this.partPickListDto };

      // this.getTrucks();

      this.loading = false;
    },

    async getRequestTypes() {
      const res = await this.$api.truckScheduleRequestType.get();
      if (!res) return;
      this.requestTypes = res;
    },

    async getJobs(projects = null, isEdit = false) {
      console.log("projects: " , projects);
      this.loadingJobs = true;
      if (!isEdit) {
        this.item.job_id = null;
        this.item.project_id = null;
      }
      this.jobs = [];
      const readModel = {
        filters: {
          inventory_class_ids: this.item.inventory_classes && this.item.inventory_classes.length > 0 ? this.item.inventory_classes.map(x => x.id) : null,
          // project_ids: projects && projects.length > 0 ? projects.map(p => p.id) : this.isView ? this.item.projects && this.item.projects.length > 0 ? this.item.projects.map(p => p.id) : null : null,
          is_sub_class: 1,
          // is_pick_list: 1,
          // is_manual: 0,
        },
        sort: {
          order_by_first: 'id',
          direction_sort: 0,
        },
      };
      const res = await this.$api.job.readDDL(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      this.loadingJobs = false;
      this.jobs = res;
    },

    async getProjects() {
      this.loadingProjects = true;
      const submitModel = {
        filters: {
          // inventory_class_id: this.item.inventory_class_id !== null ? this.item.inventory_class_id : null,
          // inventory_class_ids: this.item.inventory_classes && this.item.inventory_classes.length > 0 ? this.item.inventory_classes.map(x => x.id) : null,
        },
      };
      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        return;
      }
      if (!res || !res.data) {
        this.projects = [];
        this.loadingProjects = false;
        return;
      }
      this.projects = res.data;
      this.loadingProjects = false;
    },

    async getPickLists() {
      if (!this.item.jobs || this.item.jobs.length === 0) {
        this.pickLists = [];
        return;
      }
      this.loadingPickLists = true;
      const submitModel = {
        filters: {
          job_ids: this.item.jobs.map(j => j.id),
        },
      };
      const res = await this.$api.partPickList.readData(submitModel);
      if (!res || !res.data) {
        this.loadingPickLists = false;
        this.pickLists = [];
        return;
      }
      this.mapPickListsToJobs(res.data);
      this.loadingPickLists = false;
    },

    mapPickListsToJobs(pickLists) {
      this.item.jobs.forEach(job => {
        this.$set(
          job,
          'pick_lists',
          pickLists.filter(pl => pl.job_id === job.id)
        );
      });
    },

    async getTruckTypes() {
      this.loadingTruckTypes = true;
      const submitModel = {
        filters: {},
      };
      this.truckTypes = await this.$api.truckScheduleTruckType.read(
        submitModel
      );
      this.loadingTruckTypes = false;
    },

    async getShifts() {
      const res = await this.$api.truckScheduleRequestShift.get();
      if (!res) return;
      this.shifts = res;
    },

    async getCageTypes() {
      const res = await this.$api.truckScheduleRequestCageType.get();
      if (!res) {
        this.cageTypes = [];
        return;
      }
      this.cageTypes = res;
    },

    async submit() {
      if (!this.item) return false;
      // const date = new Date();
      // const currentDate = new Date(
      //   date.getFullYear(),
      //   date.getMonth(),
      //   date.getDate() - 1
      // );
      // if (new Date(this.item.date) < currentDate) {
      //   this.$bus.$emit('showError', 'Past dates are not allowed!');
      //   return false;
      // }
      this.$bus.$emit('loading');
      let res;
      // let truckScheduleRequestId = this.item.id;
      this.item.cage_quantities = Object.values(this.cageQuantities)
        .map(cq => ({
              id: cq.id, // may be null
              truck_schedule_request_cage_type_id: cq.truck_schedule_request_cage_type_id,
              quantity: cq.quantity
        }));

      console.log('Submitting Truck Schedule Request:', JSON.parse(JSON.stringify(this.item)));

      // let isCreate = false;
      if (this.item.id) {
        if (this.isApprove) {
          this.item.is_approve = 1;
        }
        res = await this.$api.truckScheduleRequest.update(this.item);
        this.$bus.$emit('loading-stop');
        if (!res) {
          this.$bus.$emit('showError', 'Unable to update Truck Request');
          return false;
        }
      } else {
        // isCreate = true;
        res = await this.$api.truckScheduleRequest.store(this.item);
        this.$bus.$emit('loading-stop');
        // truckScheduleRequestId = res;
        if (!res) {
          this.$bus.$emit('showError', 'Unable to create Truck Request');
          return false;
        }
      }

      // if (this.item.note && this.item.note.trim().length > 0 && this.isNewNote(this.item.note)) {
      //   const note = {
      //     text: this.item.note,
      //     record_id: truckScheduleRequestId,
      //     type_id: this.noteTypeIdTruckScheduleRequest,
      //   };
      //   const noteRes = await this.$api.note.store(note);
      //   if (!noteRes) {
      //     this.$bus.$emit(
      //       'showError',
      //       'Error adding note to delivery request'
      //     );
      //     this.$bus.$emit('loading');
      //     return false;
      //   }
      // }

      // let res2;
      // let partPickListSubmitModel = {
      //   truck_schedule_request_id: truckScheduleRequestId,
      //   ...this.partPickList,
      // }
      // if (!isCreate) {
      //   res2 = await this.$api.partPickList.update(partPickListSubmitModel, 'truck-schedule-request');
      //   if (!res2) {
      //     this.$bus.$emit('showError', 'Unable to update Pick List');
      //     return false;
      //   }
      // } else if (partPickListSubmitModel.items && partPickListSubmitModel.items.length > 0) {
      //   res2 = [];
      //   partPickListSubmitModel.is_active = 0;
      //   partPickListSubmitModel.project_id = this.item.project_id;
      //   partPickListSubmitModel.job_id = this.item.job_id;
      //   res2 = await this.$api.partPickList.store(partPickListSubmitModel, 'truck-schedule-request');
      //   if (!res2) {
      //     this.$bus.$emit('showError', 'Unable to create Pick List');
      //     return false;
      //   }
      // }

      // if (
      //   this.partPickList.items &&
      //   this.partPickList.items.length > 0 &&
      //   this.partPickList.note &&
      //   this.partPickList.note.trim().length > 0 &&
      //   this.isNewPickListNote(this.partPickList.note)
      // ) {
      //   res2.forEach(async (pickListId) => {
      //     const partPickListNote = {
      //       text: this.partPickList.note,
      //       record_id: pickListId,
      //       type_id: this.noteTypeIdPickList,
      //     };
      //     const res3 = await this.$api.note.store(partPickListNote);
      //     if (!res3) {
      //       this.$bus.$emit(
      //         'showError',
      //         'Error adding note to Pick List'
      //       );
      //       return false;
      //     }
      //   });
      // }

      this.$bus.$emit('showSuccess');
      this.$emit('success', {
        getTruckRequests: true,
        getScheduledDeliveries: this.item.id && !this.isApprove ? true : false
      });
      return true;
    },

    async approve() {
      // const confirm = await this.$refs.confirmForm.open({
      //   title: `Are you sure that you want to approve this Delivery Request?`,
      // });
      // if (!confirm) return;
      const res = await this.$api.truckScheduleRequest.get(`approve/${this.item.id}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.$emit('success', {
        getTruckRequests: true,
        getScheduledDeliveries: false,
      });
      return true;
    },

    async open(id, options = {}) {
      this.$refs.dialogBox.open();
      this.isView = options.isView || false;
      this.isApprove = options.isApprove || false;
      this.step = options.step || 1;
      if (id) {
        await this.get(id);
        const isEdit = true;
        this.getJobs(null, isEdit);
        this.truckTypes = await this.getAvailableTruckTypesByDate(this.item.date, id);
      } else {
        this.item = { ...this.itemDto };
        this.truckTypes = [];
        this.cageQuantities = {};
        this.cageTypes.forEach(ct => {
          this.cageQuantities[ct.id] = {
            id: null,
            truck_schedule_request_cage_type_id: ct.id,
            quantity: 0
          };
        });
        // this.partPickList = { ...this.partPickListDto };
      }
      // this.getJobs();
      
    },

    // openPartPickListForm() {
    //   this.$refs.partPickListForm.openFromTruckScheduleRequestForm(this.partPickList, this.isView);
    // },

    async openJobForm() {
      var res = null;
      if (this.businessRulesGetBoolean('Desa WO Codes')) {
        res = await this.$api.job.get(`generate-manual-code-desa/P`);
      } else {
        res = await this.$api.job.get('generate-manual-code');
      }
      
      if (!res) return;
      this.$refs.jobForm.open();
      this.$nextTick(() => {
        this.$refs.jobForm.item.code = res;
        this.$refs.jobForm.item.is_manual = 1;
        if (this.item.inventory_class_id)
          this.$refs.jobForm.item.inventory_class_id =
            this.item.inventory_class_id;
      });
    },

    openNoteForm() {
      this.$refs.noteForm.open(
        this.item.id,
        this.noteTypeIdTruckScheduleRequestJob,
      );
    },

    // partPickListFormSuccess(partPickList) {
    //   this.partPickList = partPickList;
    // },

    async jobSuccess() {
      this.$bus.$emit('loading');
      await this.getJobs();
      const latestItemId = Math.max(...this.jobs.map((x) => x.id));
      const latestItem = this.jobs.find(x => x.id === latestItemId);
      const latestItemProjectId = latestItem ? latestItem.project_id : null;
      this.$bus.$emit('loading-stop');
      if (latestItemId) {
        this.item.job_id = latestItemId;
        this.item.project_id = latestItemProjectId;
      }
    },

    async noteSuccess(id, text) {
      this.item.note = text;
    },

    getJobTotalWindows() {
      if (!this.item.job_id) return 0;
      const job = this.jobs.find((x) => x.id === this.item.job_id);
      if (!job || !job.total_windows) return 0;
      return job.total_windows;
    },

    onInventoryClassChange(inventoryClasses) {
      if (!inventoryClasses || inventoryClasses.length === 0) {
        this.item.inventory_classes = [];
        return;
      }
      this.item.inventory_classes = inventoryClasses;
      this.item.job_id = null;
      this.item.project_id = null;
      this.getProjects();
      this.getJobs();
    },

    // deprecated method to check if selected job is already scheduled for the date of the truck schedule request, now there is no restriction
    // async isJobAlreadyScheduled(jobId) {
    //   const scheduledDate = this.item.slot.date;
    //   const submitModel = {
    //     filters: {
    //       date: scheduledDate,
    //     },
    //   };
    //   const res = await this.$api.truckScheduleSlot.read(submitModel);
    //   if (!res) {
    //     this.$bus.$emit('showError', 'Unable to determine if job is already scheduled for this date');
    //     return false;
    //   }

    //   return res.some((scheduledDelivery) => 
    //     scheduledDelivery.requests.some((x) => x.job_id === jobId && x.id !== this.item.id)
    //   );
    // },

    updateInventoryClass(jobId) {
      if (!jobId) return;
      const job = this.jobs.find((x) => x.id === jobId);
      this.item.inventory_class_id = job.inventory_class_id;
      this.item.project_id = job.project_id;
    },

    // deprecated method to retrieve pick lists based on selected jobs, now retrieves pick lists directly on job retrieval
    // async getPickLists(jobs) {
    //   if (!jobs || !jobs.length) return;
    //   const jobIds = jobs.map(j => j.id);
    //   const submitModel = {
    //     filters: {
    //       job_ids: jobIds,
    //       inventory_class_ids: [this.inventoryClassIdInst, this.inventoryClassId4500, this.inventoryClassId4800, this.inventoryClassIdComm],
    //       status_ids: [this.pickListStatusIdNew, this.pickListStatusIdPartiallySupplied, this.pickListStatusIdSupplied, this.pickListStatusIdShipped],
    //     },
    //   };
    //   const res = await this.$api.partPickList.read(submitModel);
    //   if (!res || !res.data) {
    //     console.log('res', res);
    //     this.$bus.$emit('showError', 'Unable to retrieve Pick Lists');
    //     return;
    //   }

    //   this.item.pick_lists = res.data;
    // },

    onRequestTypeChange(requestTypeId) {
      this.item.inventory_classes = [];
      this.item.projects = [];
      this.item.jobs = [];
      //if request type is pickup then get jobs
      if (requestTypeId === this.truckScheduleRequestTypeIdPickup) {
        this.getJobs();
      }
    },

    async onJobChange() {
      //because we can select any job now without restriction, we need to make sure the job we select will set the project as well
      //so for example if we have Project A and B and we have Job 1 for Project A and Job 2 for Project B and then we select Job 3 which is for Project C, Project C must be automatically appended to item.projects
      //but it's fine if Project C is still there if we remove Job 3 because there is no restriction on the projects we can select
      const selectedProjectIds = this.item.jobs.map(j => j.project_id);
      const selectedProjects = this.projects.filter(p => selectedProjectIds.includes(p.id));
      this.item.projects = [...this.item.projects, ...selectedProjects.filter(sp => !this.item.projects.some(p => p.id === sp.id))];

      //retrieve production schedules based on the selected job and set them to the job object in item.jobs so that we can display the total windows, doors, etc... for the job in the form
      let jobIds = this.item.jobs.map(j => j.id);
      if (!jobIds || jobIds.length === 0) {
        //if no jobs selected then clear the production schedules from the job objects
        this.item.jobs.forEach(job => {
          job.production_schedules = [];
        });
        return;
      }
      const submitModel = {
        filters: {
          job_id: jobIds,
        },
      };
      this.loadingProductionSchedules = true;
      const res = await this.$api.productionSchedule.readData(submitModel);
      this.loadingProductionSchedules = false;
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data) {
        this.$bus.$emit('showError', 'Unable to retrieve production schedules for the selected jobs');
        this.item.jobs.forEach(job => {
          job.production_schedules = [];
        });
        return;
      }
      //map the production schedules to the jobs
      this.item.jobs.forEach(job => {
        job.production_schedules = res.data.filter(ps => ps.job_id === job.id);
      });
    },

    // async onDateChange(date) {
    //   //get available truck types for the selected date
    //   if (!date) return;
    //   this.item.truck_type_id = null;
    //   this.truckTypes = [];
    //   this.loadingAvailableTruckTypesByDate = true;
    //   this.availableTruckTypesByDate = {};
    //   const submitModel = {
    //     filters: {
    //       start_date: date,
    //       end_date: date,
    //     }
    //   };
    //   // const res = await this.$api.truckScheduleTruck.read(submitModel, null, 'read-available');
    //   const res = await this.$api.truckScheduleTruck.read(submitModel, null, 'read-available-truck-type-counts');
    //   const cancelCode = 3001;
    //   this.loadingAvailableTruckTypesByDate = false;
    //   if (res === cancelCode) {
    //     this.availableTruckTypesByDate = {};
    //     return;
    //   }
    //   if (!res) {
    //     this.$bus.$emit('showError', 'Unable to get available truck count by date');
    //     this.availableTruckTypesByDate = {};
    //     return;
    //   }
    //   this.availableTruckTypesByDate = res;
    //   //need to display in the truckTypes array the list of truck types where the count > 0
    //   const arrayOfTruckTypes = this.availableTruckTypesByDate[date];
    //   if (arrayOfTruckTypes && arrayOfTruckTypes.length > 0) {
    //     arrayOfTruckTypes.forEach(x => {
    //       if (x.count > 0) {
    //         let truckType = x.truck_type;
    //         truckType.count = x.count;
    //         this.truckTypes.push(truckType);
    //       }
    //     })
    //   } else {
    //     this.truckTypes = [];
    //   }
    // },

    async onDateChange(date) {
      if (!date) return;
      this.item.truck_type_id = null;
      this.truckTypes = [];
      this.truckTypes = await this.getAvailableTruckTypesByDate(date);
    },

    async getAvailableTruckTypesByDate(date, truckScheduleRequestId = null) {
      this.loadingAvailableTruckTypesByDate = true;
      this.availableTruckTypesByDate = {};

      const submitModel = {
        filters: {
          start_date: date,
          end_date: date,
          exclude_truck_schedule_request_id: truckScheduleRequestId, // to exclude the current truck schedule request when editing so that the currently selected truck type is included in the available truck types list even if its count is 0 for the selected date
        }
      };

      const res = await this.$api.truckScheduleTruck.read(submitModel, null, 'read-available-truck-type-counts');
      const cancelCode = 3001;
      this.loadingAvailableTruckTypesByDate = false;
      if (res === cancelCode) {
        this.availableTruckTypesByDate = {};
        return [];
      }
      if (!res) {
        this.$bus.$emit('showError', 'Unable to get available truck count by date');
        this.availableTruckTypesByDate = {};
        return [];
      }
      this.availableTruckTypesByDate = res;
      const truckTypes = [];
      const arrayOfTruckTypes = this.availableTruckTypesByDate[date];
      if (arrayOfTruckTypes && arrayOfTruckTypes.length > 0) {
        arrayOfTruckTypes.forEach(x => {
          if (x.count > 0) {
            truckTypes.push({
              ...x.truck_type,
              count: x.count
            });
          }
        });
      }
      return truckTypes;
    },

    onTruckTypeChange() {
      if (this.item.truck_quantity == null) {
        this.item.truck_quantity = 1;
      }
    },

    getMaxTruckQuantity() {
      //return the count of the selected truck type from this.truckTypes array
      if (!this.item.truck_type_id) return null;
      const selectedTruckType = this.truckTypes.find(x => x.id === this.item.truck_type_id);
      return selectedTruckType ? selectedTruckType.count : null;
    },

    // async getTrucks() {
    //   this.loadingTrucks = true;
    //   const submitModel = {
    //     filters: {
    //       truck_type_ids: this.item.truck_types.map((x) => x.id),
    //     },
    //   };
    //   const res = await this.$api.truckScheduleTruck.read(submitModel);
    //   if (!res) {
    //     this.loadingTrucks = false;
    //     this.$bus.$emit('showError', 'Unable to retrieve trucks');
    //     return;
    //   }
    //   this.loadingTrucks = false;
    //   this.trucks = res;
    // },

    openPickListForm(id) {
      const pickState = false;
      const isView = true;
      this.$refs.partForm.open(id, pickState, isView);
    },

    isNewNote(note) {
      if (!this.item.latest_note) return true;
      return this.item.latest_note.text !== note;
    },

    // isNewPickListNote(note) {
    //   if (!this.partPickList.latest_note) return true;
    //   return this.partPickList.latest_note.text !== note;
    // },

    isBackorderPickList(pickList) {
      return pickList && pickList.backorder_id > 0;
    },

    nextStep() {
      if (this.step === 3) {
        this.step = 1;
        return;
      }
      const currentForm = this.$refs[`step${this.step}Form`];
      if (!currentForm || currentForm.validate()) { 
        this.step += 1;
        return;
      }
    },

    prevStep() {
      if (this.step === 1) {
        this.step = 1
        return;
      }
      this.step -= 1;
    },

    allowedDates(date) {
      // Allow all dates except Sundays
      const day = new Date(date + 'T00:00:00').getDay(); // correct timezone shift
      return day !== 0;
    },

    clearJobs() {
      this.item.jobs = [];
    },

    removeJob(item) {
      this.item.jobs = this.item.jobs.filter(j => j.id !== item.id);
    },
    
    removeProject(item) {
      this.item.projects = this.item.projects.filter(p => p.id !== item.id);
    },

    isSelected(typeId) {
      return this.item && this.item.truck_types && this.item.truck_types.some((item) => item.id === typeId);
    },

    toggleType(typeId) {
      let newValue = [];

      if (this.isSelected(typeId)) {
        newValue = this.item.truck_types.filter((item) => item.id !== typeId);
      } else {
        const type = this.truckTypes.find((t) => t.id === typeId);
        newValue = [...this.item.truck_types, { ...type, quantity: 1 }];
      }

      this.item.truck_types = newValue;
    },

    getTruckTypeQuantity(typeId) {
      const truckType = this.item.truck_types.find((item) => item.id === typeId);
      return truckType ? truckType.quantity : 0;
    },

    updateQuantity(typeId, change) {
      //if the truck type hasn't been selected but user tries to update the quantity, add the truck type and update quantity to 1
      if (!this.isSelected(typeId) && change > 0) {
        const type = this.truckTypes.find((t) => t.id === typeId);
        this.item.truck_types = [...this.item.truck_types, { ...type, quantity: 1 }];
        return;
      }
      //if we decrement the quantity and it goes to 0, remove the truck type from the list
      //we need to also make sure that the quantity doesn't go below 0
      const newValue = this.item.truck_types.map((item) => {
        if (item.id === typeId) {
          const newQuantity = item.quantity + change;
          if (newQuantity <= 0) {
            return null; // mark for removal
          }
          // if the new quantity exceeds the available count for that truck type, set it to the max available count
          if (item.count && newQuantity > item.count) {
            return {
              ...item,
              quantity: item.count,
            };
          }
          return {
            ...item,
            quantity: newQuantity,
          };
        }
        return item;
      }).filter(item => item !== null); // remove truck types with quantity 0
      // const newValue = this.item.truck_types.map((item) => {
      //   if (item.type.id === typeId) {
      //     return {
      //       ...item,
      //       quantity: Math.max(1, item.quantity + change),
      //     };
      //   }

      //   return item;
      // });

      this.item.truck_types = newValue;
    },

    removeType(id) {
      const newValue = this.item.truck_types.filter((item) => item.id !== id);
      this.item.truck_types = newValue;
    },

    getTruckTypeChipStyle(typeId) {
      const selected = this.isSelected(typeId);
      const type = this.truckTypes.find((t) => t.id === typeId);

      const darker = this.darkenColor(type.color, 20);

      return {
        background: selected
          ? `linear-gradient(135deg, ${type.color}, ${darker})`
          : 'transparent',
        border: `1px solid ${type.color}`,
        color: selected ? '#FFFFFF' : type.color,
        cursor: 'pointer',
        borderRadius: '6px',
      };
    },

    getTotalTruckTypeQuantity() {
      return this.item.truck_types.reduce((total, item) => total + item.quantity, 0);
    },

    darkenColor(hex, percent) {
      const num = parseInt(hex.replace('#', ''), 16);
      const amt = Math.round(2.55 * percent);

      const r = Math.max((num >> 16) - amt, 0);
      const g = Math.max(((num >> 8) & 0x00ff) - amt, 0);
      const b = Math.max((num & 0x0000ff) - amt, 0);

      return `#${(
        (1 << 24) +
        (r << 16) +
        (g << 8) +
        b
      )
        .toString(16)
        .slice(1)}`;
    },
  }
};
</script>

<style scoped>
::v-deep .wrap-text {
  white-space: normal !important;
}
::v-deep .hover-on-disabled {
  pointer-events: auto;
}
.v-stepper__header {
  border-top: lightgrey 1px solid;
  border-bottom: lightgrey 1px solid;
}
.v-stepper__label {
  font-size: 1.2rem;
}
.v-stepper__step--active > .v-stepper__label {
  font-weight: bold;
}
.v-stepper__content {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid lightgrey;
}
.v-stepper__header {
  box-shadow: none !important;
}
.job-list {
  height: 250px;
  max-height: 300px;
  overflow-y: auto;
  border-radius: 5px !important;
  background-color: rgb(240, 240, 240) !important;
}

#pick-list {
  height: 300px;
}

.picklists-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.picklists-menu-wrap {
  display: flex;
  flex-wrap: wrap;
}

/* Table */
::v-deep .dr-table .v-data-table__wrapper table thead.v-data-table-header tr th {
  background-color: transparent;
  height: 32px;
}
::v-deep .dr-table .v-data-table__wrapper table thead.v-data-table-header tr th span {
  color: #7b7b7b;
}
::v-deep .dr-table td {
  font-size: 15px;
}
::v-deep .truck-type-btn:hover {
  opacity: 0.9;
}
</style>
